import React from 'react';
import { Loader, Center, Box, Text } from '@mantine/core';

interface LoadingComponentProps {
  message?: string;
}

export const LoadingComponent: React.FC<LoadingComponentProps> = ({ 
  message = "ページを読み込み中..." 
}) => {
  return (
    <Center style={{ height: '300px' }}>
      <Box style={{ textAlign: 'center' }}>
        <Loader size="lg" mb="md" />
        <Text size="sm" c="dimmed">
          {message}
        </Text>
      </Box>
    </Center>
  );
};

export default LoadingComponent;